import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { User } from "~/types/user";

type AuthState = {
  token: string | null;
  userId: string | null;
  user: User | null;
};

type AuthActions = {
  setAuth: (token: string, userId: string, user: User) => void;
  setUser: (user: User) => void;
  logout: () => void;
};

export const useAuthStore = create<AuthState & AuthActions>()(
  persist(
    (set) => ({
      token: null,
      userId: null,
      user: null,
      setAuth: (token, userId, user) => set({ token, userId, user }),
      setUser: (user) => set({ user }),
      logout: () => set({ token: null, userId: null, user: null }),
    }),
    {
      name: "auth-storage",
      partialize: (state) => ({
        token: state.token,
        userId: state.userId,
        user: state.user,
      }),
    },
  ),
);
